import { isConsumer } from 'owa-session-store';
import { isAccountFeatureEnabled } from 'owa-feature-flags';
import type { MailboxInfo } from 'owa-client-types';

export default function isSenderScreeningFeatureEnabled(mailboxInfo: MailboxInfo): boolean {
    return (
        isConsumer(undefined, mailboxInfo) &&
        isAccountFeatureEnabled('tri-sender-screening', mailboxInfo)
    );
}
